import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaFacebookF, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { navLinksdata } from "../../constants";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();  // Fix for ESLint error (no global 'location')

  return (
    <div className="w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600">
      <div>
        <span className="text-[rgb(255_1_79/1)] text-2xl font-semibold">Portfolio</span>
      </div>

      <div>
        <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
          {navLinksdata.map(({ _id, title, link }) => (
            <li
              key={_id}
              className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
            >
              {link.startsWith("/") ? (
                // External page (like /gallery)
                <RouterLink to={link}>{title}</RouterLink>
              ) : location.pathname === "/" ? (
                // Internal scroll when on homepage
                <ScrollLink
                  activeClass="active"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {title}
                </ScrollLink>
              ) : (
                // Redirect to homepage with hash when on another page
                <RouterLink to={`/#${link}`}>{title}</RouterLink>
              )}
            </li>
          ))}

          {/* WhatsApp Icon for Desktop */}
          <li className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300">
            <a
              href="https://wa.me/919876543210?text=May%20I%20help%20you%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <FaWhatsapp className="text-2xl text-green-500" />
              WhatsApp
            </a>
          </li>
        </ul>

        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          <FiMenu />
        </span>

        {showMenu && (
          <div className="w-[80%] h-screen overflow-scroll absolute top-0 left-0 bg-gray-900 p-4 scrollbar-hide">
            <div className="flex flex-col gap-8 py-2 relative">
              <span className="text-[rgb(255_1_79/1)] text-2xl font-semibold">Portfolio</span>

              <p className="text-sm text-gray-400 mt-2">
                Creative and detail-oriented Graphic Designer with 2.5 years of hands-on experience
                in designing marketing creatives, social media posts, and branding assets using
                Canva, Adobe Photoshop and Illustrator. Passionate about clean design and visual
                storytelling that grabs attention and delivers impact.
              </p>

              <ul className="flex flex-col gap-4">
                {navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  >
                    <ScrollLink
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </ScrollLink>
                  </li>
                ))}
              </ul>

              <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
                <div className="flex gap-4">
                  <span className="bannerIcon">
                    <FaFacebookF />
                  </span>
                  <span className="bannerIcon">
                    <a
                      href="https://wa.me/919129019994?text=May%20I%20help%20you%3F"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-500"
                    >
                      <FaWhatsapp />
                    </a>
                  </span>
                  <span className="bannerIcon">
                    <FaInstagram />
                  </span>
                </div>
              </div>

              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-designColor duration-300 text-2xl cursor-pointer"
              >
                <MdClose />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
